import { createI18n } from "vue-i18n";
import enRaw from "../../../locales/en.default.json?raw";

const en = JSON.parse(enRaw.replace(/^\/\*[\s\S]*?\*\/\s*/, ""));

const messages = {
  en: en,
};

const i18n = createI18n({
  locale: "en",
  fallbackLocale: "en",
  messages,
});

export default i18n;
